import { Stack } from "expo-router";
import Head from "expo-router/head";

import { PortalGate } from "../../lib/PortalGate";

export default function AdminLicensingLayout() {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <PortalGate portal="admin">
        <Stack screenOptions={{ headerShown: false }} />
      </PortalGate>
    </>
  );
}
